import { render, staticRenderFns } from "./LabelStatementsTopSlot.vue?vue&type=template&id=9a640506"
import script from "./LabelStatementsTopSlot.vue?vue&type=script&lang=js"
export * from "./LabelStatementsTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports